<template>
<AdminPanelEGiftsPackageSelling />
</template>

<script>
import AdminPanelEGiftsPackageSelling from '../components/AdminPanelEGiftsPackageSelling.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsPackageSelling
    },
    methods: {},
    mounted() {}
}
</script>